// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"styles_main-layout__AUJKB","shop":"styles_shop__2Rgbr","logo-wrapper":"styles_logo-wrapper__2Gtly","logo":"styles_logo__fiuTQ","empty":"styles_empty__2dWbC"};